import { Component, OnInit } from '@angular/core';
import { Server, Connection, UserData, AuthResponse, User, AgentView, AgentData } from 'src/app/models/server-v2';

import { RpaIdClientService } from 'src/app/services/net/rpa-id-client.service';

import { SyncService } from 'src/app/services/sync/sync.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmatorDialogComponent, ConfirmData } from 'src/app/components/confirmator-dialog/confirmator-dialog.component';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';

import jwt_decode from 'jwt-decode';
import { Router } from '@angular/router';
import { MediaSizeService } from 'src/app/services/media-size.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-user-managmet',
  templateUrl: './user-managmet.component.html',
  styleUrls: ['./user-managmet.component.scss']
})
export class UserManagmetComponent implements OnInit {
  //sync
  public msg = ""
  running = false
  complete = false
  message = ""
  //сервера
  servers: Server[] = []
  server = ''
  //email = ''
  code = ''
  phone = ''
  externalToken = ''
  activeUserId: string | undefined
  activeUser: User | undefined
  profiles: AgentView[] = []

  profile = new FormControl<AgentView | undefined>(undefined)
  profiles$!: Observable<AgentView[]>
  // mobile = false
  appleInput = ''

  constructor(public sync: SyncService,

    public connMgr: ConnectionManagerService,
    private api: RpaIdClientService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    public media: MediaSizeService,


  ) {
    this.activeUser = JSON.parse(JSON.stringify(this.connMgr.activeUser))
    this.activeUserId = this.activeUser?.id;

  }


  ngOnInit(): void {

    this.getServers()
    this.getProfiles()
  }


  private auto() {
    this.profiles$ = this.profile.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.profiles.slice();
      }),
    );

  }

  private _filter(name: string): AgentView[] {
    if (!name) return this.profiles
    const filterValue = name.toLowerCase();

    return this.profiles.filter(prof => prof.name.toLowerCase().includes(filterValue));
  }

  displayFn(prof: AgentData): string {
    return prof && prof.name ? prof.name : '';
  }

  isAdmin() {
    return this.connMgr.isAdmin()
  }

  isSuper() {
    return this.connMgr.isSuper()
  }


  changeActiveUser() {
    if (!this.activeUserId) {
      return
    }

    const user = this.connMgr.users.find(u => u.id == this.activeUserId)

    if (!user) {
      return
    }
    this.activeUser = user;
    this.activeUserId = this.activeUser?.id;

    this.connMgr.setActiveUser(this.activeUser)
    // this.profile = undefined
    this.profile.setValue(undefined)
    this.getProfiles()
  }

  //serv
  getServers() {
    this.api.getServers().subscribe({
      next: x => {
        this.servers = x;

        if (!x || x.length <= 0) {
          this.snack.open("получен пустой список регионов", "Ok", { duration: 1500 })
        }

      },
      error: err => {
        console.log(err)
        this.snack.open("ошибка загрузки списка регионов", "Ok", { duration: 1500 })
      }
    })
  }

  getProfiles() {
    if (!this.connMgr.activeUser || !this.connMgr.activeUser.user?.Phone || !this.connMgr.activeUser.user?.Phone) {
      return
    }
    this.profiles = []
    this.auto()
    const filter = {
      //email: this.connMgr.activeUser.user.Email,
      phone: this.connMgr.activeUser.user.Phone,
      server: this.connMgr.activeUser.user.Server,
      sendEmail: true,
    }
    this.api.getProfiles(filter).subscribe({
      next: x => {
        this.profiles = x;

        if (this.connMgr.Connections){
          this.connMgr.Connections.forEach(c=>{
            const p = this.profiles.find(s=>s.code == c.agent.Code);
            if (p){
              p.exists = true;
            }
          })
        }


        this.auto();

        if (this.profiles && this.profiles.length === 1) {

          if (this.connMgr.activeServer) {
            return
          }

          this.addConn(this.profiles[0])
        }

      },
      error: err => { this.snack.open('Ошибка загрузки агентов', 'Закрыть', { duration: 5000 }) }
    })

  }



  checkTimeConn(connection: Connection) {
    if (connection.agentToken) {
      const decodeToken = jwt_decode<AgentData>(connection.agentToken)
      const conDate = new Date(decodeToken.exp * 1000)
      if (conDate.getTime() < new Date().getTime()) {
        return true
      }
    }
    return false
  }

  //редактирование серверов
  deleteServ(conn: Connection) {

    const dialogConfirm = this.dialog.open(ConfirmatorDialogComponent, {
      data: {
        title: 'Удаление',
        question: `Удалить подключение  ${conn.title}?`,
        buttonOkName: 'Да',
        buttonCancelName: 'Отмена'
      } as ConfirmData
    })

    dialogConfirm.afterClosed().subscribe(x => {
      if (x) {
        this.connMgr.deleteConnection(conn)
      }
    })
  }

  deleteUser() {
    const dialogConfirm = this.dialog.open(ConfirmatorDialogComponent, {
      data: {
        title: 'Удаление',
        question: `Удалить подключение  ${this.connMgr.activeUser.user.name}?`,
        buttonOkName: 'Да',
        buttonCancelName: 'Отмена'
      } as ConfirmData
    })

    dialogConfirm.afterClosed().subscribe(x => {
      if (x) {
        this.connMgr.delUser(this.connMgr.activeUser)
        this.activeUser = JSON.parse(JSON.stringify(this.connMgr.activeUser))
        this.activeUserId = this.activeUser?.id;
        this.getProfiles()
      }
    })



  }

  activeServ(serv: Connection) {

    const curr = this.connMgr.activeServer;

    if (!curr || !curr.agent) {
      return false
    }


    if (curr?.agent?.Code === serv.agent?.Code && curr?.agent?.Server === serv?.agent?.Server) {
      return true
    }
    return false
  }





  async deleteAll() {

    const dialogConfirm = this.dialog.open(ConfirmatorDialogComponent, {
      data: {
        title: 'Удаление',
        question: 'Удалить базы данных и все настройки подюклячений?',
        buttonOkName: 'Да',
        buttonCancelName: 'Отмена'
      } as ConfirmData
    })

    dialogConfirm.afterClosed().subscribe(x => {
      if (x) {

        this.connMgr.users.forEach(x => {
          this.connMgr.delUser(x)
        })

        this.connMgr.Connections.forEach(async (x) => {

          this.connMgr.deleteConnection(x)
        })

        // document.location.reload() // зачем?

      }
    })


  }

  applyExternalToken() {
    this.router.navigate(['bot-auth', this.externalToken])
  }

  addConn(agent: AgentView | undefined | null) {
    if (!agent?.code || !agent.server) return

    this.api.requestAccess(agent.code, agent.server).subscribe({
      next: x => { this.addUpdcon(x) },
      error: err => {
        console.error(err);
        this.snack.open('Не удалось добавить подключение', 'Закрыть', { duration: 5000 })
      }
    },)
  }

  addUpdcon(auth: AuthResponse) {

    if (!auth.successfull) {
      this.snack.open(auth.message, 'Закрыть', { duration: 5000 })
      return
    }

    const token = auth.payload
    const agent = jwt_decode<AgentData>(token)
    // не прочитали токен
    if (!agent) {
      this.snack.open('Не удалось добавить подключение', 'Закрыть', { duration: 5000 })
      return
    }


    const agentCode = agent.Code
    const server = agent.Server

    // в токене указан неизвестный код сервера
    const findserv = this.servers.find(x => x.name === server)
    if (!findserv) {
      this.snack.open('Ошибка выбора сервера подключения', 'Закрыть', { duration: 5000 })
      return
    }

    const connectionId = server + '-' + agentCode;

    const current = this.connMgr.Connections.find(x => x.id === connectionId)

    // такое подключение уже есть
    if (current) {

      this.snack.open('Уже есть такое подключение - обновлено', 'Закрыть', { duration: 5000 })
      const refTokenDecode = jwt_decode<AgentData>(current.agentToken)

      if (refTokenDecode.exp < agent.exp) {

        // обновляем токен
        current.agentToken = token
        current.agent = agent

        this.connMgr.updateConnection(current)
        return
      }
    }

    const serverad: Connection = {
      id: connectionId,
      active: false,
      title: "[" + findserv.name + "] " + agent.name,
      agentToken: token,
      agent: agent,
      server: findserv
    }

    this.connMgr.addConnection(serverad)

    if (this.profiles && this.profiles.length === 1) {
      this.router.navigate(["sync"])

    }

  }

  appleReg() {
    const splitHref = this.appleInput.split('/')
    const tokenInx = splitHref.findIndex(x => x === 'bot-auth') + 1

    // console.log(tokenInx)
    // console.log(splitHref[tokenInx])
    this.router.navigate(['bot-auth', splitHref[tokenInx]])
  }


}
